import React, { Component } from 'react';
import { connect } from 'react-redux';
import LogIn from './LogIn';
import SignUp from './SignUp';
import { ResetPassword } from './ResetPassword';

import { toggleModal } from '../../../actions/ViewController';
import { modalTypes } from '../../../consts';
import { TRootState } from '../../../reducers';

type TAuthModalProps = {
    authModal: string;
    forceModal?: boolean;
    toggleModal: (modal: string, type: string) => void;
}

class AuthModal extends Component<TAuthModalProps> {
    constructor(props: TAuthModalProps) {
        super(props);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose() {
        if (!this.props.forceModal) {
            this.props.toggleModal('authModal', null);
        }
    }

    render() {
        if (this.props.authModal === modalTypes.LOGIN) {
            // @ts-ignore
            return <LogIn onRequestClose={this.onRequestClose} />;
        }
        if (this.props.authModal === modalTypes.SIGNUP) {
            // @ts-ignore
            return <SignUp />;
        }
        if (this.props.authModal === modalTypes.RESET_PASSWORD) {
            // @ts-ignore
            return <ResetPassword onRequestClose={this.onRequestClose} />;
        }
        return null;
    }
}

function mapStateToProps(state: TRootState) {
    return {
        authModal: state.view.modals.authModal,
    };
}

export default connect(mapStateToProps, { toggleModal })(AuthModal);
